import { MSerializer, MSerializers } from "@legacy-megarax/serializers";

export interface IdObjectDto {
  id: number;
  str: string;
}

export interface ActiveRevisionDto extends IdObjectDto {
  activeId: number;
}

export interface AnyRevisionDto extends IdObjectDto {
  activeId: number | null;
}

export const idObjectSerializer = MSerializers.object<IdObjectDto>({
  id: MSerializers.integer,
  str: MSerializers.string,
});

export const activeRevisionSerializer = MSerializers.object<ActiveRevisionDto>({
  id: MSerializers.integer,
  str: MSerializers.string,
  activeId: MSerializers.integer,
});

export interface IdObjectReference {
  id: number;
}
export const idObjectReferenceSerializer = MSerializers.object<IdObjectReference>({
  id: MSerializers.integer,
});

export interface UuidObjectReference {
  uuid: string;
}
export const uuidObjectReferenceSerializer = MSerializers.object<UuidObjectReference>({
  uuid: MSerializers.uuid(),
});

export interface RevisionReference {
  activeId: number;
}

export const revisionReferenceSerializer = MSerializers.object<RevisionReference>({
  activeId: MSerializers.integer,
});

export interface PaginatedList<T> {
  /**
   * A list of matched items or a part of it if the list was paginated.
   */
  items: T[];
  /**
   * Total number of matched items, counted before pagination.
   */
  count: number;
}

export const paginatedListSerializer = <T>(unitSerializer: MSerializer<T>) =>
  MSerializers.object<{
    count: number;
    items: T[];
  }>({
    count: MSerializers.integer,
    items: MSerializers.array<T>(unitSerializer),
  });

export const revisionDetailDtoSerializer = MSerializers.object({
  ...idObjectSerializer.fields,
  activeId: MSerializers.integer.nullable(),
  isActive: MSerializers.boolean,
  target: activeRevisionSerializer.optional(),
  isDraft: MSerializers.boolean,
  isFinalized: MSerializers.boolean,
  drafts: MSerializers.object({
    ...idObjectSerializer.fields,
    draftCreatedAt: MSerializers.datetime,
  }),
});
